import InvictusTestCriteria from 'components/Invictus/InvictusTestCriteria'
import WhyInvictus from 'components/Invictus/WhyInvictus'
import InvictusTeachercontri from 'components/Invictus/InvictusTeachercontri'
import InvictusEliteProgram from 'components/Invictus/InvictusEliteProgram'
import InvictusHowRegister from 'components/Invictus/InvictusHowRegister'

const InvictusLandingTemplate = () => {
  return (
    <div>
      <InvictusTestCriteria />
      <WhyInvictus />
      <InvictusTeachercontri />
      <InvictusEliteProgram />
      <InvictusHowRegister />
    </div>
  )
}

export default InvictusLandingTemplate